import { render } from "./CreateMedicament.vue?vue&type=template&id=43360dee&scoped=true"
import script from "./CreateMedicament.vue?vue&type=script&lang=js"
export * from "./CreateMedicament.vue?vue&type=script&lang=js"

import "./CreateMedicament.vue?vue&type=style&index=0&id=43360dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43360dee"]])

export default __exports__